export default __webpack_public_path__ + "static/media/13.b1251222.svg";